import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Query } from '@apollo/client/react/components';

import Styled from 'styled';
import ErrorPage from 'four-nets/errors/error-page';
import AdUnit from 'lib/google/dfp/google-dfp';
import { InterscrollerPlaceholder } from 'lib/google/dfp/ad-units/interscroller';
import { ForumRectangle, ZoznamBoxin} from 'lib/google/dfp/ad-units/forum-rectangle';
import { Site } from 'four-nets/site';

import btoa from 'lib/base64/btoa';

import PlaceholderPost from '../posts/feed-post/placeholder-post';
import FeedPost from '../posts/feed-post/feed-post';
import defaultStyles from './feed.scss';
import CollectionFeed from 'four-nets/photoblog/collections/collection-post/collection-post';
import collectionsQuery, {
    RecentCollectionsQuery,
} from 'four-nets/photoblog/collections/collection-post/collection-post.graphql';

export interface Props {
    styles: typeof defaultStyles;
    data: any;
    loading: boolean;
    refetch: () => void;
    loadImages?: () => void;
    imageId?: string;
    nonMainFeed?: boolean;
    mySelection?: boolean;
    showFeedAds?: boolean;
    postId?: string;
    openComments?: boolean;
    site: Site;
}

export interface State {
    search?: string;
}

class Feed extends React.PureComponent<Props, State> {
    state: State = {};

    render() {
        const { styles, data, refetch, imageId, nonMainFeed, mySelection, showFeedAds, openComments, site } = this.props;
        let collectionFeedPostIndex: number | null = null;
        let after: string | null;

        return data?.feed?.edges ? (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    {data.feed.edges.length > 0 ? (
                        data.feed.edges.map((postNodeEdge: any, index: number) => {
                            if (!postNodeEdge || !postNodeEdge.node) {
                                return null;
                            }

                            // Calculate index of CollectionFeed, we display first after 5 posts and
                            // then each next 15 posts apart
                            // XXX: Kinda hacky, but we create "after" cursor from
                            // the collectionFeedPostIndex
                            // Each CollectionFeed contains 3 collections, that's
                            // why collectionFeedPostIndex * 3.
                            if (index === 5) {
                                collectionFeedPostIndex = 0;
                                after = null;
                            } else if ((index - 5) % 15 === 0) {
                                // just to satisfy typechecker, shouldn't ever be null here
                                collectionFeedPostIndex = collectionFeedPostIndex ? collectionFeedPostIndex : 0;

                                collectionFeedPostIndex = ((index - 5) / 15) >> 0;
                                after = btoa(`arrayconnection:${collectionFeedPostIndex * 3}`);
                            } else {
                                collectionFeedPostIndex = null;
                            }

                            return (
                                <React.Fragment key={postNodeEdge.node.id || index.toString()}>
                                    <FeedPost
                                        refetch={refetch}
                                        imageId={imageId}
                                        openComments={openComments}
                                        {...postNodeEdge.node}
                                    />
                                    {!nonMainFeed && collectionFeedPostIndex !== null ? (
                                        <Query<RecentCollectionsQuery>
                                            query={collectionsQuery}
                                            fetchPolicy='cache-first'
                                            variables={{ after }}
                                        >
                                            {({ loading, data, error }) => (
                                                <ErrorPage error={error}>
                                                    <CollectionFeed loading={loading} data={data} />
                                                </ErrorPage>
                                            )}
                                        </Query>
                                    ) : null}
                                    {index === 2 && showFeedAds ? (
                                        <InterscrollerPlaceholder style={{ marginTop: 10 }} />
                                    ) : null}
                                    {(index === 3 || (index > 0 && index % 27 === 0)) && showFeedAds ? (
                                        <AdUnit
                                            style={{ wrapper: styles.feedAdWrapper }}
                                            adUnitCode='feed-post'
                                            sizes={['fluid']}
                                        />
                                    ) : null}
                                    {index === 6 && showFeedAds ? (
                                        <>
                                            {site.isWedding && site.isSlovak ? <ZoznamBoxin position='top' /> : <ForumRectangle />}
                                        </>
                                    ): null }
                                    {index === 10 && showFeedAds ? (
                                        <InterscrollerPlaceholder style={{ marginTop: 10 }} />
                                    ) : null}
                                    {index === 14 && showFeedAds ? (
                                        <>
                                            {site.isWedding && site.isSlovak ? <ZoznamBoxin position='bottom' /> : <ForumRectangle adUnitCode='forum-rectangle-bottom'/>}
                                        </>
                                    ): null }
                                </React.Fragment>
                            );
                        })
                    ) : (
                        <div className={styles.empty}>
                            {mySelection ? (
                                <FormattedMessage id='NO_POSTS_MY_SELECTION' />
                            ) : (
                                <FormattedMessage id='NO_POSTS' />
                            )}
                        </div>
                    )}
                </div>
            </div>
        ) : (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    {[null, null, null, null].map((_, index) => (
                        <PlaceholderPost key={`placeholder_${index}`} />
                    ))}
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Feed);
